import React from 'react';
import './style.css';
import theme from '@/constants/theme';

type SkeletonProps = React.HTMLAttributes<HTMLSpanElement> & {
  width?: string | number;
  height?: string | number;
  borderRadius?: string;
};

const Skeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height = '16px',
  borderRadius = '8px',
  style,
  className = '',
  ...rest
}) => {
  return (
    <span
      className={`custom-skeleton ${className}`}
      style={{
        width,
        height,
        borderRadius,
        backgroundColor: theme.colors.skeleton,
        ...style,
      }}
      {...rest}
    />
  );
};

export default Skeleton;
